module.exports = __webpack_public_path__ + "static/gavilanwork7-6c5203eb67eb7caddd6b2468fedbd955.png";